module.exports = __webpack_public_path__ + "static/media/IMG-9573.f974fd43.JPG";